import type { MantineColorsTuple } from '@mantine/core';

export const BRAND: MantineColorsTuple = [
    '#F0FDFA', '#CCFBF1', '#99F6E4', '#5EEAD4', '#2DD4BF',
    '#14B8A6', '#0D9488', '#0F766E', '#115E59', '#134E4A',
];

export const SUCCESS: MantineColorsTuple = [
    '#F0FDF4', '#DCFCE7', '#BBF7D0', '#86EFAC', '#4ADE80',
    '#22C55E', '#16A34A', '#15803D', '#166534', '#14532D',
];

export const WARNING: MantineColorsTuple = [
    '#FFFBEB', '#FEF3C7', '#FDE68A', '#FCD34D', '#FBBF24',
    '#F59E0B', '#D97706', '#B45309', '#92400E', '#78350F',
];

export const DANGER: MantineColorsTuple = [
    '#FEF2F2', '#FEE2E2', '#FECACA', '#FCA5A5', '#F87171',
    '#EF4444', '#DC2626', '#B91C1C', '#991B1B', '#7F1D1D',
];

export const INFO: MantineColorsTuple = [
    '#EFF6FF', '#DBEAFE', '#BFDBFE', '#93C5FD', '#60A5FA',
    '#3B82F6', '#2563EB', '#1D4ED8', '#1E40AF', '#1E3A8A',
];

export const DARK: MantineColorsTuple = [
    '#C6C7CC', '#ABADB4', '#878A93', '#63666F', '#44464E',
    '#30323A', '#23252B', '#18191E', '#101114', '#0A0B0D',
];

export const TYPE_SCALE = {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.333rem',
    h1: '1.777rem',
    display: '2.369rem',
} as const;

export const SPACE = {
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
} as const;

export const SHELL = {
    headerHeight: 60,
    navbarExpanded: 268,
    navbarCollapsed: 72,
    navbarTransitionMs: 220,
} as const;

export const TAG_PALETTE = {
    red: { light: '#DC2626', dark: '#F87171' },
    orange: { light: '#EA580C', dark: '#FB923C' },
    yellow: { light: '#CA8A04', dark: '#FACC15' },
    green: { light: '#16A34A', dark: '#4ADE80' },
    blue: { light: '#2563EB', dark: '#60A5FA' },
    purple: { light: '#7C3AED', dark: '#A78BFA' },
    gray: { light: '#64748B', dark: '#94A3B8' },
} as const;

export const TAG_TINT = {
    red: { light: 'rgba(220, 38, 38, 0.10)', dark: 'rgba(248, 113, 113, 0.14)' },
    orange: { light: 'rgba(234, 88, 12, 0.10)', dark: 'rgba(251, 146, 60, 0.14)' },
    yellow: { light: 'rgba(202, 138, 4, 0.12)', dark: 'rgba(250, 204, 21, 0.14)' },
    green: { light: 'rgba(22, 163, 74, 0.10)', dark: 'rgba(74, 222, 128, 0.13)' },
    blue: { light: 'rgba(37, 99, 235, 0.10)', dark: 'rgba(96, 165, 250, 0.13)' },
    purple: { light: 'rgba(124, 58, 237, 0.10)', dark: 'rgba(167, 139, 250, 0.14)' },
    gray: { light: 'rgba(100, 116, 139, 0.12)', dark: 'rgba(148, 163, 184, 0.14)' },
} as const;
